import { Body, Button, getPictureProps, Grid, Lockup, theme } from '@superhi/design'
import React from 'react'
import { Blurhash } from 'react-blurhash'

import { BackgroundImage } from '../../BackgroundImageWarped/styles'

import { BlurhashWrapper, Wrapper, Content } from './styles'

type Color = 'blue' | 'yellow'

const CONFIG: Record<
  Color,
  {
    imageUrl: string
    backgroundColor: keyof typeof theme.colors
    blurHash: string
  }
> = {
  blue: {
    imageUrl: 'https://superhi.s3.amazonaws.com/assets/images/blue-03-header.png',
    blurHash: 'e7M[UGX7yP*9yP.etyRBMktMtfMRy6yPaORCV_kAkSowahjakAbGod',
    backgroundColor: 'WARM_BLUE_30',
  },
  yellow: {
    imageUrl:
      'https://superhi.s3.amazonaws.com/assets/images/unlimited-membership/community-background-large.png',
    blurHash: 'e7M[UGX7yP*9yP.etyRBMktMtfMRy6yPaORCV_kAkSowahjakAbGod',
    backgroundColor: 'YELLOW_40',
  },
}

type Props = {
  title: string
  titleMaxWidth?: number
  subtitle?: string
  subtitleMaxWidth?: number
  footer?: string
  color?: Color
  button?: Pick<React.ComponentProps<typeof Button>, 'children' | 'href'>
}

export const PageHeader: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  titleMaxWidth = 32,
  subtitle,
  subtitleMaxWidth = 28,
  footer,
  color,
  button,
  ...commonProps
}) => {
  const config = React.useMemo(
    () => ({
      image:
        color &&
        getPictureProps({
          small: {
            path: CONFIG[color].imageUrl,
            width: 100,
            options: {
              fm: 'jpg',
              ar: '75:100',
              fit: 'crop',
            },
          },
          medium: {
            path: CONFIG[color].imageUrl,
            width: 100,
            options: {
              fm: 'jpg',
              ar: '100:50',
              fit: 'crop',
            },
          },
          large: {
            path: CONFIG[color].imageUrl,
            width: 100,
            options: {
              fm: 'jpg',
              ar: '100:40',
              fit: 'crop',
            },
          },
          xlarge: {
            path: CONFIG[color].imageUrl,
            width: 100,
            options: {
              fm: 'jpg',
              ar: '100:30',
              fit: 'crop',
            },
          },
        }),
      color: color && CONFIG[color].backgroundColor,
      blurHash: color && CONFIG[color].blurHash,
    }),
    [color],
  )

  return (
    <Wrapper data-component-name="PageHeader" {...commonProps}>
      {config.image && (
        <BackgroundImage
          {...config.image}
          blurHash={config.blurHash}
          backgroundColor={config.color}
          fit="cover"
          position="center center"
          alt=""
        />
      )}

      <Grid>
        <Grid.Cell span="full">
          <Content>
            <Lockup
              title={title}
              subtitleMarkdown={subtitle}
              titleMaxWidth={titleMaxWidth}
              subtitleMaxWidth={subtitleMaxWidth}
            />
            {button && <Button {...button} level="1" />}
            {footer && <Body level="4">{footer}</Body>}
          </Content>
        </Grid.Cell>
      </Grid>
    </Wrapper>
  )
}

export default PageHeader
